import lodash from "lodash";
import {
    createFieldDatetime,
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { getDeep } from "../../../../../utils/list";

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });
export const callRequestDocGenType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC_GEN_TYPE", value: searchQuery });
export const callRequestDepartment = ({ refRequestDocKey }) =>
    store
        .dispatch("resource/v1/master/requestDepartment/cacheFindAll", {
            where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: refRequestDocKey }],
            sort: [{ name: "refDepartment.nameTh", type: "ASC" }],
            criteria: { select: ["**"] }
        })
        .then(requestDepartments => {
            const departmentIds = requestDepartments.map(requestDepartment => requestDepartment.refDepartment.id);
            return callDepartment().then(departments => getDeep({ items: departments, findFunc: ({ item }) => departmentIds.includes(item.id) }));
        });
export const callUserCompanyMe = () => {
    const userInfo = store.state.resource.auth.info?.user;
    const username = userInfo?.username;
    const where = [
        // company 1
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true },

        { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
        { name: "username", type: "String", operator: "=", value: username },
        // company 1 emploees
        { logic: "OR", openBucket: true, name: "employees.isActive", type: "Boolean", operator: "=", value: true },
        { name: "employees.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "employees.refStatus.key", type: "String", operator: "=", value: "active" },
        { closeBucket: true, name: "employees.username", type: "String", operator: "=", value: username },
        { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
    ];
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "idCard", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "companyNameTh", type: "ASC" }],
                children: [
                    {
                        name: "addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "userObjectives",
                        select: ["*", "refObjective.*"],
                        page: 0,
                        size: 1000000
                    }
                ]
            }
        })
        .then(page => page.data);
};
export const callUserCompany = ({ searchQuery, userInfo, isOfficerCreate, userAuthorizeRole }) => {
    const username = userInfo?.username;
    const where = [
        // company 1
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true }
    ];
    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "username", type: "String", operator: "=", value: username },
            // company 1 emploees
            { logic: "OR", openBucket: true, name: "employees.isActive", type: "Boolean", operator: "=", value: true },
            { name: "employees.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "employees.refStatus.key", type: "String", operator: "=", value: "active" },
            { closeBucket: true, name: "employees.username", type: "String", operator: "=", value: username },

            // (userAuthorizes and (company2 OR employees))
            // userAuthorizes type 2
            { logic: "OR", openBucket: true, name: "userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "userAuthorizes.roles.refRole.name", type: "String", operator: "=", value: userAuthorizeRole },
            // userAuthorizes type 1
            { name: "userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id", type: "Getpath", operator: "=", value: "id" },
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            // company 2
            { openBucket: true, name: "userAuthorizes.refAuthorize.isActive", type: "Boolean", operator: "=", value: true },
            { name: "userAuthorizes.refAuthorize.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "userAuthorizes.refAuthorize.refStatus.key", type: "String", operator: "=", value: "active" },
            { closeBucket: true, name: "userAuthorizes.refAuthorize.username", type: "String", operator: "=", value: username },
            // company 2 employees
            { logic: "OR", openBucket: true, name: "userAuthorizes.refAuthorize.employees.isActive", type: "Boolean", operator: "=", value: true },
            { name: "userAuthorizes.refAuthorize.employees.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "userAuthorizes.refAuthorize.employees.refStatus.key", type: "String", operator: "=", value: "active" },
            { closeBucket: true, name: "userAuthorizes.refAuthorize.employees.username", type: "String", operator: "=", value: username },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "companyNameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullNameTh", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "idCard", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "companyNameTh", type: "ASC" }],
                children: [
                    {
                        name: "addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "userObjectives",
                        select: ["*", "refObjective.*"],
                        page: 0,
                        size: 1000000
                    }
                ]
            }
        })
        .then(page => page.data);
};
export const callUser = ({ searchQuery, userCompanyId, userAuthorizeRole }) => {
    const whereAdd1 = [];
    const whereAdd2 = [];
    if (userAuthorizeRole) {
        whereAdd1.push({
            name: "userAuthorizes.refAuthorize.userAuthorizes.roles.refRole.name",
            type: "String",
            operator: "=",
            value: userAuthorizeRole
        });
        whereAdd2.push({
            name: "refParent.userAuthorizes.refAuthorize.userAuthorizes.roles.refRole.name",
            type: "String",
            operator: "=",
            value: userAuthorizeRole
        });
    }
    const where = [
        // user
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
        // user person
        { openBucket: true, name: "id", type: "UUID", operator: "=", value: userCompanyId },
        { closeBucket: true, name: "refPersonType.key", type: "String", operator: "=", value: "2" },
        //{ name: "id", type: "UUID", operator: "=", value: userCompanyId },
        // parent
        { logic: "OR", openBucket: true, name: "refParent.isActive", type: "Boolean", operator: "=", value: true },
        { name: "refParent.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refParent.refStatus.key", type: "String", operator: "=", value: "active" },
        { closeBucket: true, name: "refParent.id", type: "UUID", operator: "=", value: userCompanyId },
        // userAuthorizes type 1
        { logic: "OR", openBucket: true, name: "userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
        { name: "userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
        { name: "userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userCompanyId },
        // userAuthorizes type 2
        { name: "userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
        { name: "userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
        { name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id", type: "Getpath", operator: "=", value: "id" },
        ...whereAdd1,
        {
            closeBucket: true,
            name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.refPersonType.key",
            type: "String",
            operator: "=",
            value: "2"
        },
        // parentUserAuthorizes type 1
        { logic: "OR", openBucket: true, name: "refParent.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
        { name: "refParent.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refParent.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "refParent.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
        { name: "refParent.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userCompanyId },
        // parentUserAuthorizes type 2
        { name: "refParent.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
        { name: "refParent.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refParent.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "refParent.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
        ...whereAdd2,
        {
            closeBucket: true,
            name: "refParent.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
            type: "Getpath",
            operator: "=",
            value: "refParent.id"
        },
        { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
    ];
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "fullNameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "companyNameTh", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "idCard", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "fullNameTh", type: "ASC" },
                    { name: "companyNameTh", type: "ASC" }
                ],
                children: [
                    {
                        name: "addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    }
                ]
            }
        })
        .then(page => page.data);
};

export const createField = ({ props, data, key }) => {
    const { viewOnly, dataTempKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDocGenType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.request.refDocGenType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDocGenType,
                            "onUpdate:value": value => {
                                model.refDocGenType = value;
                                if (model.refRequestType?.key === "1") {
                                    model.requestCode = null;
                                    lodash.get(model, dataTempKey).approveManualDate = null;
                                    lodash.get(model, dataTempKey).effectiveDate = null;
                                    if (props.approveCodeKey) lodash.get(model, dataTempKey)[props.approveCodeKey] = null;
                                    if (props.approveCodeKey2) lodash.get(model, dataTempKey)[props.approveCodeKey2] = null;
                                }
                            },
                            disabled: viewOnly && model.refRequestType?.key === "1",
                            list: callRequestDocGenType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            "onUpdate:value": value => (model.requestCode = value),
                            // disabled: viewOnly || model.refDocGenType?.key === "1"
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.${props.approveCodeKey}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey)[props.approveCodeKey],
                            "onUpdate:value": value => (lodash.get(model, dataTempKey)[props.approveCodeKey] = value),
                            // disabled: viewOnly || model.refDocGenType?.key === "1"
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => props.approveCodeKey2 && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.${props.approveCodeKey2}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => props.approveCodeKey2Label,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey)[props.approveCodeKey2],
                            "onUpdate:value": value => (lodash.get(model, dataTempKey)[props.approveCodeKey2] = value),
                            disabled: viewOnly || model.refDocGenType?.key === "1"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartment`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.requestor.to"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment,
                            "onUpdate:value": value => {
                                model.refDepartment = value;
                                lodash.get(model, dataTempKey).refDepartment = value;
                            },
                            disabled: viewOnly,
                            list: () => callRequestDepartment({ refRequestDocKey: model.refRequestDoc?.key }).then(data => ["06", "07", "16", "17", "18", "19"].includes(model.refRequestDoc?.key) ? lodash.cloneDeep(data).filter(d => d.fullCode === '10608').map(d => ({...d, children: []})) : data),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: model?.refStorageLocationTemp != null ? false : true 
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartment.nameEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.request.refDepartment")} (EN)`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment?.nameEn,
                            "onUpdate:value": value => (model.refDepartment.nameEn = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.draft.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.requestor.draftDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.draft?.[0]?.statusDatetime,
                            "onUpdate:value": value => (model.lastStatus.draft[0].statusDatetime = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.waitReceive.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.requestor.requestDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.waitReceive?.[0]?.statusDatetime,
                            "onUpdate:value": value => (model.lastStatus.waitReceive[0].statusDatetime = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.waitApprove.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.requestor.receiveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.waitApprove?.[0]?.statusDatetime,
                            "onUpdate:value": value => (model.lastStatus.waitApprove[0].statusDatetime = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDatetime({
                visible: ({ field }) => model.lastStatus.approve?.[0]?.statusDatetime && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.approve.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.requestor.approveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.approve?.[0]?.statusDatetime,
                            "onUpdate:value": value => (model.lastStatus.approve[0].statusDatetime = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                inputRender: () => <div></div>
            },
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUserCompany.idCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.register.idTax"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey).refUserCompany?.idCard,
                            "onUpdate:value": value => (lodash.get(model, dataTempKey).refUserCompany.idCard = value),
                            disabled: viewOnly,
                            comma: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUser.idCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    ["1"].includes(lodash.get(model, dataTempKey).refUser?.refPersonType?.key)
                        ? i18n.global.t("views.register.idTax")
                        : i18n.global.t("model.user.idCard"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey).refUser?.idCard,
                            "onUpdate:value": value => (lodash.get(model, dataTempKey).refUser.idCard = value),
                            disabled: viewOnly,
                            comma: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUserCompany`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey).refUserCompany,
                            "onUpdate:value": value => {
                                lodash.get(model, dataTempKey).refUserCompany = value;
                                const refOperation = checkUserCompanyOperation({
                                    operations: props.dataProp.userObjectives || [],
                                    userCompany: value
                                })[0];
                                props.dataProp.onUpdateRefOperation?.(refOperation);
                                if (model.isOfficerCreate) {
                                    lodash.get(model, dataTempKey).refUser = null;
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callUserCompany({
                                    searchQuery,
                                    userInfo: store.state.resource.auth.info?.user,
                                    isOfficerCreate: model.isOfficerCreate,
                                    userAuthorizeRole: props.userAuthorizeRole
                                }),
                            renderLabel: ({ item }) => {
                                if (item.refPersonType?.key === "1") {
                                    return <div>{item.companyNameTh}</div>;
                                }
                                return <div>{item.fullNameTh}</div>;
                            },
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.companyNameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUser`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refUser"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey).refUser,
                            "onUpdate:value": value => (lodash.get(model, dataTempKey).refUser = value),
                            disabled: viewOnly || !lodash.get(model, dataTempKey).refUserCompany || !model.isOfficerCreate,
                            list: ({ searchQuery }) =>
                                callUser({
                                    searchQuery,
                                    userCompanyId: lodash.get(model, dataTempKey).refUserCompany.id,
                                    userAuthorizeRole: props.userAuthorizeRole
                                }),
                            renderLabel: ({ item }) => {
                                if (item.refPersonType?.key === "1") {
                                    return <div>{item.companyNameTh}</div>;
                                }
                                return <div>{item.fullNameTh}</div>;
                            },
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: {
                    getValue: ({ record, field }) =>
                        lodash.get(record, `${field.key}.${record.refPersonType?.key === "1" ? "companyNameTh" : "fullNameTh"}`)
                }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUserCompany.companyNameEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.request.refUserCompany")} (EN)`,
                inputProp: ({ field }) => {
                    let name = lodash.get(model, dataTempKey).refUserCompany?.fullNameTh;
                    if (lodash.get(model, dataTempKey).refUserCompany?.refPersonType?.key === "1") {
                        name = lodash.get(model, dataTempKey).refUserCompany?.companyNameTh;
                    }
                    return lodash.merge(
                        {
                            value: name,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUser.fullNameEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.request.refUser")} (EN)`,
                inputProp: ({ field }) => {
                    let name = lodash.get(model, dataTempKey).refUser?.fullNameTh;
                    if (lodash.get(model, dataTempKey).refUser?.refPersonType?.key === "1") {
                        name = lodash.get(model, dataTempKey).refUser.companyNameTh;
                    }
                    return lodash.merge(
                        {
                            value: name,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUserCompany.addresses.0.addrTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.modelName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey).refUserCompany?.addresses?.[0]?.addrTh,
                            "onUpdate:value": value => (lodash.get(model, dataTempKey).refUserCompany.addresses[0].addrTh = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}${dataTempKey}.refUser.addresses.0.addrTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.modelName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, dataTempKey).refUser?.addresses?.[0]?.addrTh,
                            "onUpdate:value": value => (lodash.get(model, dataTempKey).refUserCompany.addresses[0].addrTh = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const checkUserCompanyOperation = ({ operations, userCompany }) => {
    const userObjectiveKeys = userCompany.userObjectives.map(d => d.refObjective.key);
    return operations.filter(d => userObjectiveKeys.includes(d.key));
};
